// Validates YouTube video links to embed in ArticleText module

const YOUTUBE_VIDEO_EMBED_URL = "https://www.youtube.com/embed/";

// Gets YouTube video ID and returns an embed URL
export const getYouTubeEmbedUrl = (link: string): string => {
  const url = new URL(link);
  const videoId = url.searchParams.get("v");

  return `${YOUTUBE_VIDEO_EMBED_URL}${videoId}`;
};
